import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'api/ApiClient';

import { QueryKeys } from './common';

export const useStatusPageIncident = () => {
  return useQuery({
    queryKey: [QueryKeys.getStatusPageIncidents],
    queryFn: () => apiClient.getStatusPageIncidents(),
    refetchInterval: 1000 * 60 * 60,
    select: (data) => data.at(0),
    refetchOnWindowFocus: true,
  });
};
